import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  CONFIGURATION_DIALOG_ACTIONS,
  ConfigurationState,
  DocumentTypesDialogData,
} from '@data-access/configurations';
import { DocumentTypeDialogComponent } from '../components';
import { ComponentType } from '@angular/cdk/overlay';

@Injectable()
export class DocumentTypeDialogService {
  private readonly _store = inject(Store<ConfigurationState>);

  open(data: DocumentTypesDialogData) {
    this._store.dispatch(
      CONFIGURATION_DIALOG_ACTIONS.openConfigurationDialog({
        component: () =>
          DocumentTypeDialogComponent as ComponentType<DocumentTypeDialogComponent>,
        data: data,
      }),
    );
  }
}
